
import { Component, Prop, Vue, TSX } from 'vue-facing-decorator'
import { FORM_TYPE_LIST, FORM_WEEK_LIST, FORM_DATE_TYPE, DEFAULT_INTERVAL, isOptionType } from '@/common/sign'
interface Props {
  modelValue?: any
}
@Component({
  emits: ['resolve', 'reject']
})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop()
  modelValue: any;

  typeList = FORM_TYPE_LIST;
  weekList = FORM_WEEK_LIST;

  form: any = {
    name: '',
    placeholder: '',
    type: 1,
    isRequire: 0,
    isSystem: 0,
    content: null,
  }

  get isOptionType() {
    return isOptionType(this.form.type);
  }

  get isDateType() {
    return this.form.type == FORM_DATE_TYPE;
  }

  get optionList() {
    return this.form.content?.list || [];
  }

  created() {
    let row = this.modelValue || {};
    let type = Number(row.type) || 1;
    this.form = {
      name: row.name || '',
      placeholder: row.placeholder || '',
      type,
      /** 用 == 归一化，兼容后端把 tinyint 传成字符串 */
      isRequire: row.isRequire == 1 ? 1 : 0,
      isSystem: row.isSystem == 1 ? 1 : 0,
      content: this.buildContent(type, row.content),
    };
  }

  /** 换类型就重建 content，不然会残留上一个类型的配置（比如单选改文本还带着 options） */
  changeType(type) {
    this.form.content = this.buildContent(type, null);
  }

  changeRequire(val) {
    this.form.isRequire = val;
  }

  /**
   * 单选/多选要选项列表，时间预约要星期 + 时间范围，
   * 其余类型不需要 content，置空避免残留之前类型的配置
   */
  buildContent(type, content) {
    content = content || {};
    if (isOptionType(type)) {
      let list = (content.list || []).map((item) => {
        return { name: item.name, value: item.value };
      });
      return { list: list.length ? list : [{ name: '', value: '' }] };
    }
    if (type == FORM_DATE_TYPE) {
      return {
        weekDays: content.weekDays || [],
        startTime: content.startTime || '',
        endTime: content.endTime || '',
        interval: content.interval || DEFAULT_INTERVAL,
      };
    }
    return null;
  }

  addOption() {
    this.form.content.list.push({ name: '', value: '' });
  }

  removeOption(index) {
    this.form.content.list.splice(index, 1);
  }

  submitForm() {
    let name = `${this.form.name || ''}`.trim();
    if (!name) return this.$error('请输入字段名称');
    if (name.length > 25) return this.$error('字段名称不能超过25个字');
    if (`${this.form.placeholder || ''}`.length > 50) return this.$error('输入提示不能超过50个字');

    let content = null;
    if (this.isOptionType) {
      let list = this.optionList.filter((item) => item.name || item.value);
      /** 后端 checkRow 的原话：单/多选必须带选项，不然前台渲染不出东西 */
      if (!list.length) return this.$error('请至少添加一个选项');
      if (list.some((item) => !item.name || !item.value)) {
        return this.$error('选项名称和选项值都要填写');
      }
      content = { list };
    } else if (this.isDateType) {
      let { weekDays, startTime, endTime, interval } = this.form.content;
      if (!weekDays || !weekDays.length) return this.$error('请选择可预约的星期');
      if (!startTime || !endTime) return this.$error('请选择可约时间范围');
      /** 'HH:mm' 定长零填充，字符串比较等价于时间先后 */
      if (startTime >= endTime) return this.$error('开始时间要早于结束时间');
      if (!interval || interval < 1) return this.$error('请填写大于 0 的间隔分钟数');
      content = { weekDays, startTime, endTime, interval };
    }

    /**
     * spread modelValue 是为了把已有的 id 原样带回去：
     * 编辑时漏了 id，后端会当成新字段、把老的那条删掉重插
     */
    this.$emit('resolve', {
      ...this.modelValue,
      name,
      placeholder: this.form.placeholder,
      type: this.form.type,
      isRequire: this.form.isRequire,
      isSystem: this.form.isSystem,
      content,
    });
  }
}
